module.exports = __webpack_public_path__ + "img/ordernumber_010_icon.76d7afae.png";